import React from 'react';
import { useNavigate } from 'react-router-dom';
import ClientHelpCenter from '../components/ClientHelpCenter';
import { useBusinessStore } from '../store/useBusinessStore';

export default function AcademyPage() {
  const { masterDb, activeBusinessId } = useBusinessStore();
  const navigate = useNavigate();
  const activeBusiness = masterDb.find(b => String(b.id) === String(activeBusinessId));

  if (!activeBusiness) return <div>Cargando...</div>;

  return (
    <ClientHelpCenter
      activeBusiness={activeBusiness}
      onClose={() => navigate('/v2/dashboard')}
    />
  );
}
